import { Component, Input, OnInit, ViewChild } from '@angular/core';

import { MafFormControlComponent, Parser, ValidateResult } from 'maf-web';
import { ToastrService } from 'ngx-toastr';
import { AppService } from '../../app.service';
import { ConsumidorSiteClientModelService } from '../../service/consumidorsiteclient.model.service';
import { ConsClienteAPP, ConsumidorSiteResponseGetConsumidorV0APP, DataParametrosAPP } from '../../vo/sitevo.vo';

@Component({
  selector: 'modal-confirmacao',
  templateUrl: './modal-confirmacao.component.html',
  styleUrls: ['../modal.component.css']
})
export class ModalConfirmacaoComponent implements OnInit {

  chaveConfirmacao: string = '';
  isValidConfirmacao: ValidateResult = { valid: true };
  isLoadingConfirmacao: boolean = false;
  isLoading: boolean = true;
  isError: boolean = false;

  @Input() dataConfirmacao: ConsumidorSiteResponseGetConsumidorV0APP;
  @ViewChild('setFocusConfirmacao', {static: false}) focusConfirmacaoElement: MafFormControlComponent;

  constructor(
    private app: AppService,
    private consumidor: ConsumidorSiteClientModelService,
    private toastrService: ToastrService
  ) { }

  ngOnInit(): void {
    if (this.dataConfirmacao == null || this.app.consCliente.dadosResumidos) {
      this.consumidor.envioConfirmacaoDados(this.app.consCliente.getPK())
        .then((data: ConsumidorSiteResponseGetConsumidorV0APP) => {
          this.dataConfirmacao = data;
          this.setFocusConfirmacao();
        })
        .catch(erro => {
          this.isError = true;
          console.error(erro);
        })
        .then(() => this.isLoading = false);
    } else {
      this.isLoading = false;
      this.setFocusConfirmacao();
    }
  }

  get parametrosAPP(): DataParametrosAPP { return this.app.parametrosAPP; }

  formatarWhats(): string {
    return Parser.formataFone(this.app.parametrosAPP.whatsApp + '');
  }

  private setFocusConfirmacao() {
    if (this.focusConfirmacaoElement) {
      this.focusConfirmacaoElement.setFocus();
    } else {
      const self = this;
      setTimeout(() => self.setFocusConfirmacao(), 50);
    }
  }

  validarChaveConfirmacao() {
    this.isLoadingConfirmacao = true;
    this.consumidor.confirmacaoValidaByCliente(this.app.consCliente.getPK(), this.dataConfirmacao.tipoConfirmacao, Parser.strToInt(this.chaveConfirmacao))
      .then((data: ConsClienteAPP) => {
        if (data != null && data.getPK().codCliente > 0) {
          this.app.consCliente = data;
          this.app.modalConfirmacaoEvent.emit();
          this.fechar();
        } else {
          this.isValidConfirmacao = { valid: false, message: 'A chave informada não é valida.'};
          return undefined;
        }
      })
      .catch(error => {
        this.removeToastrService();
        let errorMessage = error;
        if (error.mensagem) {
          errorMessage = error.mensagem;
        }
        this.isValidConfirmacao = { valid: false, message: errorMessage};
        console.error(error);
      })
      .then(() => this.isLoadingConfirmacao = false);
  }


  private removeToastrService() {
    if (this.toastrService.toasts.length > 0) {
      for (const toast of this.toastrService.toasts) {
        this.toastrService.remove(toast.toastId);
      }
      const self = this;
      setTimeout(() => self.removeToastrService(), 50);
    }
  }

  fechar() {
    this.app.modalConfirmacao = false;
  }

  validacaoWhatsApp() {
    const linkApi: string = this.app.isMobile ? 'api' : 'web';
    const a = document.createElement('a');
    a.target = '_blank';
    a.href = `https://${linkApi}.whatsapp.com/send?phone=55${this.app.lojaWhatsApp}&text=${encodeURI(`Olá, preciso de ajuda para validar meu cadastro, pode me ajudar?`)}`;
    a.click();
  }

}
